import cn from 'clsx'

import { SearchIcon } from '@App/static/icons/SpotOrderIcons'
import { TextField } from '@App/ui/crypto_exchange/desktop/components/controls/TextField'

import s from './SearchInput.module.scss'
type Props = {
  containerClassName?: string
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export const SearchInput = ({ containerClassName, className, ...props }: Props) => {
  return (
    <TextField
      {...props}
      containerClassName={cn(s.container, containerClassName)}
      className={cn(s.input, className)}
      leftIcon={<SearchIcon className={s.icon} />}
      cleareable
    />
  )
}
